import { render, staticRenderFns } from "./CharityGiftModal.vue?vue&type=template&id=7bed49e6"
import script from "./CharityGiftModal.vue?vue&type=script&lang=js"
export * from "./CharityGiftModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports